import request from '@/utils/request';

//货号
export function queryCategoryPage(values) {
  return request('/product/queryCategoryPage', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
//新品配置接口
export function addNewProduct(values) {
  return request('/activityNewProduct/addNewProduct', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
//新品配置接口编辑
export function updateNewProduct(values) {
  return request('/activityNewProduct/updateNewProduct', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
//新品配置接口详情
export function queryNewProductDetail(values) {
  return request('/activityNewProduct/queryNewProductDetail', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}